<template>
  <div class="grid menu">

	<div class="grid actions">

		<!-- <button class="grid btn" @click="show('seasons')"><span class="grid icon"><img src="/img/icons/seasons.svg"></span> Stagioni e prezzi</button> -->
		<div class="grid flatbox border visible-xs">{{$store.state.hotels.activehotel.name}}</div>
		<div class="grid btn visible-xs" @click="sethotelDialog = true"><span class="grid icon"><unicon fill="#333" name="clipboard-notes" height="24" width="24" /></span><span> Cambia spiaggia</span> </div>
		<div v-if="$store.state.user.privileges.admin" class="grid btn hidden-xs" @click="show('seasons')"><span class="grid icon"><unicon fill="#333" name="clipboard-notes" height="24" width="24" /></span><span> Stagioni e prezzi</span> </div>
		<div v-if="$store.state.user.privileges.admin" class="grid btn hidden-xs" @click="show('editgrid')"><span class="grid icon"><unicon fill="#333" name="draggabledots" height="24" width="24" /></span> Modifica spiaggia</div>
		<div v-if="$store.state.user.privileges.admin" class="grid btn hidden-xs" @click="show('settings')"><span class="grid icon"><unicon fill="#333" name="sliders-v-alt" height="24" width="24" /></span> Impostazioni</div>
		<div v-if="$store.state.user.privileges.admin" class="grid btn" @click="show('subusers')"><span class="grid icon"><unicon fill="#333" name="users-alt" height="24" width="24" /></span> Utenze</div>
		<div class="spacer sm"></div>
		<div v-if="$store.state.user.privileges.admin" class="grid btn hidden-xs" @click="show('broadcast')"><span class="grid icon"><unicon fill="#333" name="megaphone" height="24" width="24" /></span> Broadcast</div>
		<!-- <p>{{hotel.items}}</p> -->
	</div>
	<div class="grid footer">
		<button @click="logout()" class="btn reddark sm"><unicon name="sign-out-alt" height="16" width="16" fill="#fff" />logout</button>
	</div>

	<el-dialog
		title="Seleziona spiaggia"
		:visible.sync="sethotelDialog || $store.state.hotels.selecthoteldialog"
		:fullscreen="true"
		:append-to-body="true"
		:show-close="false"
		custom-class="hotelselector">
		<div class="grid list">
			<div class="grid flatbox" v-for="hot in hotels" :key="hot._id" @click="setHotel(hot), sethotelDialog = false, show('dashboard')">{{hot.name}}</div>
			<div class="spacer xs"></div>
			<div class="grid flatbox border">
				<small>Per aggiungere una spiaggia ti invitiamo ad usare il sistema su un dispositivo Desktop o Tablet.</small>
			</div>
			<div class="spacer xs"></div>
			<button class="btn dark" @click="sethotelDialog = false">chiudi</button>
		</div>
	</el-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
export default {
  name: 'Menu',
  props: {
	hotel: Object
  },
  data () {
	return {
		sethotelDialog: false
	}
  },
  methods: {
	logout () {
		localStorage.clear()
		this.$router.replace('/login')
	},
	show (section) {
		console.log(section)
		this.$emit('open', section)
	},
	setHotel (hotel) {
		console.log(hotel)
		console.log('setHotel')
		this.$store.dispatch('getUser')
		this.$store.commit('hotels/SET_ACTIVEHOTEL', hotel)
		console.log(this.$store.state.ombrelloni.ombrelloni.length)
		var privileges
		if (hotel.user === this.$store.state.user.id) {
			privileges = {
				owner: true,
				admin: true
			}
		} else {
			privileges = _.find(this.$store.state.user.profile.hotels, {hotelid: hotel._id})?.privileges ?? {}
		}
		this.$store.dispatch('ombrelloni/getOmbrelloni').then(() => {
			if (this.$store.state.ombrelloni.ombrelloni.length === 0) {
				console.log('no ombrelloni')
				this.$emit('open', 'editgrid')
			} else {
				this.show('dashboard')         
			}
		})
		this.$store.commit('SET_PRIVILEGES', privileges)
		this.$store.dispatch('guests/getGuests')
		this.$store.commit('hotels/SET_SELECTHOTELDIALOG', false)
		console.log(this.$store.state.ombrelloni.ombrelloni.length)
	}
  },
  filters: {
	occupation (value) {
		// console.log(value.length)
		var actual = _.filter(value, function (o) {
			// console.log('o: ', o)
			return _.find(o.guests, function (g) {
				// console.log('o: ', g.length)
				return moment().isBetween(g.arrival, g.departure)
			})
		})
		// console.log(actual)
		return ((actual.length / value.length) * 100).toFixed(1)
	}
  },
  computed: {
	hotels () {
		return this.$store.state.hotels.hotels
	},
	ombrelloni () {
		var self = this
		return _.chain(self.$store.state.ombrelloni.ombrelloni).filter(function (o) {
			return o.hotelid === self.$store.state.hotels.activehotel._id
		}).orderBy('ombrid').value()
	}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
